import { GQLOrderFragment, GQLOrderItemTileFragment, GQLOrderStatusType } from '@theprintbar/graphql';
import { getAvailableOrderRefund } from '../payment';

export const sortedOrderStatuses: GQLOrderStatusType[] = [
	GQLOrderStatusType.PendingPayment,
	GQLOrderStatusType.PendingApproval,
	GQLOrderStatusType.Created,
	GQLOrderStatusType.StockOrdered,
	GQLOrderStatusType.StockReceived,
	GQLOrderStatusType.Picked,
	GQLOrderStatusType.Printed,
	GQLOrderStatusType.Shipped,
	GQLOrderStatusType.Delivered,
	GQLOrderStatusType.Cancelled,
];

export const orderHasCompleted = (order: Pick<GQLOrderFragment, 'status'>) => {
	return sortedOrderStatuses.indexOf(order.status) >= sortedOrderStatuses.indexOf(GQLOrderStatusType.Shipped);
};

//Items can only be added while the order is still ours to change: not yet approved for production
//and not yet handed to the warehouse
export const orderCanAddItems = (order: Pick<GQLOrderFragment, 'status' | 'internalId'>) =>
	!order.internalId && sortedOrderStatuses.indexOf(order.status) <= sortedOrderStatuses.indexOf(GQLOrderStatusType.PendingApproval);

export const canCancelOrder = (order: Pick<GQLOrderFragment, 'status'>, staff?: boolean) => {
	const statusIndex = sortedOrderStatuses.indexOf(order.status);
	return statusIndex < sortedOrderStatuses.indexOf(staff ? GQLOrderStatusType.Shipped : GQLOrderStatusType.StockOrdered);
};

export const canRefundOrder = (order: GQLOrderFragment) => {
	return !!getAvailableOrderRefund(order).totalAvailableRefund;
};

export const orderItemCanCancel = (orderItem: GQLOrderItemTileFragment, order: GQLOrderFragment) => {
	return !orderItem.cancelled && !orderHasCompleted(order);
};
